import { List, Typography } from 'antd';
const { Text} = Typography;

const OnTimeCollection = () => {

  const data = [
      'İleri slotlu sipariş olup toplanmışsa hesaba dahil edilir, toplanmamış ise dahil edilmez.',
      'Bir siparişin hedef toplama zamanı geçti ise sipariş Yeni statüsünde olsa dahi başarısız olarak orana yansır.',
      'İptal edilen siparişler buraya yansımaz.',
      'Günlük performansta 00:00’dan itibaren bakılan ana kadar işlem gören ve görmesi gereken siparişler üzerinden oran gösterilir.',
      'Aylık performansta ilgili ayın 1’inden itibaren o ana kadar olan siparişler üzerinden oran gösterilir.',
      'İlgili oran merkez tarafından belirlenen hedef değerinden daha yüksekse yeşil, düşükse kırmızı renk ile gösterilir.'
  ];

  return (<List
    className="demo-loadmore-list"
    itemLayout="horizontal"
    dataSource={data}
  >
    <List.Item.Meta
      style={{ marginBottom: 10 }}
      title={
        <Text strong style={{ fontSize: 16 }}>
          İlgili dağıtım tarihine ait siparişlerin ne kadarının uygulamada gösterilen Hedef toplama zamanına kadar
          toplanıp toplanmadığını gösteren orandır.
        </Text>
      }
    />
    <ul>
      {data.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
    </ul>
  </List>);
};

export default OnTimeCollection;
